/** @format */

import styled from '@emotion/styled';

const StyledTagText = styled.span``;

export default StyledTagText;
